<div class="container">
  <div class="row mt-3">
    <div class="col-12">
      <button
        *ngIf="strand"
        type="button"
        class="btn btn-link text-decoration-none strand-title"
        (click)="isCollapsed = !isCollapsed">
        {{ strand.title }}
        <span
          ><i class="bi bi-caret-{{ isCollapsed ? 'up' : 'down' }}-fill"></i
        ></span>
      </button>
    </div>
  </div>
  <div *ngIf="strand">
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
      <div class="container p-0">
        <div class="row g-lg-2 g-xxl-3 row-cols-lg-4">
          <div class="col-lg mb-3">
            <app-preview-leveled-competency-strand-level
              [level]="1"
              [levelName]="level1name"
              [strand]="
                strand.indicators[0]
              "></app-preview-leveled-competency-strand-level>
          </div>
          <div class="col-lg mb-3">
            <app-preview-leveled-competency-strand-level
              [level]="2"
              [levelName]="level2name"
              [strand]="
                strand.indicators[1]
              "></app-preview-leveled-competency-strand-level>
          </div>
          <div class="col-lg mb-3">
            <app-preview-leveled-competency-strand-level
              [level]="3"
              [levelName]="level3name"
              [strand]="
                strand.indicators[2]
              "></app-preview-leveled-competency-strand-level>
          </div>
          <div class="col-lg mb-3">
            <app-preview-leveled-competency-strand-level
              [level]="4"
              [levelName]="level4name"
              [strand]="
                strand.indicators[3]
              "></app-preview-leveled-competency-strand-level>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
